import {
  ActiveErrorResponse,
  DashboardFilterType,
  FaultCode,
  DashboardInstallationData,
  InstallationSummary,
  ViError,
  ButtonFilterDataName,
  DashboardFilterValues,
  DashboardFilterName,
} from '@vi-iot/client';
import { Observable } from 'rxjs';
import { Platform } from '../installation-details';

export interface QuickViewDashboardData {
  smartNotes: QuickViewSmartNotes[];
  equipmentSummary: InstallationSummary;
  installation: DashboardInstallationData;
  quickViewDeviceIndex: number;
}

export interface QuickViewSmartNotes extends ActiveErrorResponse {
  loading: boolean;
  faultCodes?: FaultCode[];
  error?: ViError;
}

export interface QuickViewErrorDetails {
  errorCode: string;
  cause: string[];
  errorDescription: string;
  appearedAt: string; // date
  loading: boolean;
  error: ViError;
}

export interface DashboardFilter {
  filterName: DashboardFilterName;
  label: string;
  type: DashboardFilterType;
  value: boolean | DashboardFilterValues | string; // string is applicable for fulltext
}

export const standaloneImagePath = 'assets/img/devices/standalone.png';

export interface MoveKanbanColumnInput {
  movedColumnIndex: number;
  movedColumnId: number;
  targetColumnIndex: number;
  targetColumnId: number;
}

export interface EditColumnNameActionInput {
  id: number;
  leftNeighbor: number;
  name: string;
  installations: number[];
}

export const initialNumberOfInstallationsInColumn = 10;
export const initialNumberOfInstallationsInListView = 10;
export const limitOfSelfDefinedColumns = 50;

export interface DashboardListFilterButtonData {
  filterName: DashboardFilterName;
  filterValue: DashboardFilterValues[] | boolean;
  customName: ButtonFilterDataName;
  quantity: number;
  label?: string;
  isActive$?: Observable<boolean>;
}

export interface UpgradePackageButtonData {
  visible: boolean;
  platform: Platform;
}

export interface DashboardRefreshModalData {
  listView?: boolean;
}
export const selectedKanbanPage = 'selectedKanbanPage';
